export function initializeComparisonTable() {
    const tableWrapper = document.querySelector('.comparison-table-wrapper');
    
    if (!tableWrapper) return;

    const table = tableWrapper.querySelector('table');
    if (!table) return;

    const mobileWrapper = document.createElement('div');
    mobileWrapper.className = 'comparison-mobile-wrapper';

    const versionSelector = document.createElement('div');
    versionSelector.className = 'version-selector';
    versionSelector.innerHTML = `
        <div class="color-block"></div>
        <div class="version-dropdown">
            <button class="dropdown-toggle" type="button">
                <span class="toggle-text">Free Version</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            <div class="dropdown-menu">
                <button class="version-option active" data-version="1">Free Version</button>
                <button class="version-option" data-version="2">Premium Version</button>
                <button class="version-option" data-version="3">Custom Add-in</button>
            </div>
        </div>
    `;

    const featureList = document.createElement('div');
    featureList.className = 'feature-list';

    mobileWrapper.appendChild(versionSelector);
    mobileWrapper.appendChild(featureList);

    tableWrapper.parentNode.insertBefore(mobileWrapper, tableWrapper.nextSibling);

    const rows = Array.from(table.querySelectorAll('tbody tr')).map(tr => {
        const cells = Array.from(tr.querySelectorAll('td'));
        const featureCell = cells[0].querySelector('.td-cell');
        
        const svg = featureCell.querySelector('svg');
        const featureText = Array.from(featureCell.childNodes)
            .filter(node => node.nodeType === Node.TEXT_NODE)
            .map(node => node.textContent.trim())
            .join(' ');

        return {
            featureSvg: svg ? svg.outerHTML : '',
            featureText: featureText,
            versions: [
                cells[1].querySelector('.td-cell').innerHTML,
                cells[2].querySelector('.td-cell').innerHTML,
                cells[3].querySelector('.td-cell').innerHTML
            ]
        };
    });

    const dropdownToggle = versionSelector.querySelector('.dropdown-toggle');
    const dropdownMenu = versionSelector.querySelector('.dropdown-menu');
    const toggleText = versionSelector.querySelector('.toggle-text');
    const versionOptions = versionSelector.querySelectorAll('.version-option');

    let currentVersion = 0;

    function renderFeatures(versionIndex) {
        featureList.innerHTML = '';

        rows.forEach(row => {
            const featureItem = document.createElement('div');
            featureItem.className = 'feature-item';

            featureItem.innerHTML = `
                <div class="feature-header">
                    ${row.featureSvg}
                    <span>${row.featureText}</span>
                </div>
                <div class="feature-value">
                    ${row.versions[versionIndex]}
                </div>
            `;

            featureList.appendChild(featureItem);
        });
    }

    dropdownToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdownMenu.classList.toggle('show');
        dropdownToggle.classList.toggle('show');
    });

    document.addEventListener('click', (e) => {
        if (!versionSelector.contains(e.target)) {
            dropdownMenu.classList.remove('show');
            dropdownToggle.classList.remove('show');
        }
    });

    versionOptions.forEach((option) => {
        option.addEventListener('click', (e) => {
            e.stopPropagation();
            
            const versionIndex = parseInt(option.dataset.version) - 1;
            const versionText = option.textContent.trim();

            versionOptions.forEach(opt => opt.classList.remove('active'));
            option.classList.add('active');

            toggleText.textContent = versionText;

            dropdownMenu.classList.remove('show');
            dropdownToggle.classList.remove('show');

            currentVersion = versionIndex;
            renderFeatures(versionIndex);
        });
    });

    renderFeatures(0);
}